import axios from 'axios'

import { BACKEND_URL } from '../constants'

const listHrcGuidance = () => {
  const url = `${BACKEND_URL}/api/v1/hrc/guidance/`
  return axios.get(url)
}

const updateHrcGuidance = (file) => {
  const url = `${BACKEND_URL}/api/v1/hrc/guidance/`
  const formData = new FormData()
  formData.append("file", file)
  return axios.patch(url, formData)
}

export const hrcServices = {
  listHrcGuidance,
  updateHrcGuidance,
}
